import { render, staticRenderFns } from "./chemInfo.vue?vue&type=template&id=04c6154e"
import script from "./chemInfo.vue?vue&type=script&lang=js"
export * from "./chemInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04c6154e')) {
      api.createRecord('04c6154e', component.options)
    } else {
      api.reload('04c6154e', component.options)
    }
    module.hot.accept("./chemInfo.vue?vue&type=template&id=04c6154e", function () {
      api.rerender('04c6154e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mdm/mam/chemInfo.vue"
export default component.exports